"use client";

import Link from "next/link";
import { RENTAL_VEHICLES } from "@/data/vehicles";
import VehicleCard from "@/(global)/location/vehicules/components/VehicleCard";
import { motion } from "framer-motion";
import type { Locale } from "@/config/i18n";
import { VEHICULE_SECTION, vehiclesBasePath } from "./locationHubContent";
import { tr } from "@/config/localeText";

export default function VehiculeSection({
  locale = "fr",
}: {
  locale?: Locale;
}) {
  const chrome = tr(VEHICULE_SECTION, locale);
  // Prendre les 6 premiers véhicules pour la section "à la une"
  const featuredVehicles = RENTAL_VEHICLES.slice(0, 6);

  return (
    <section className="bg-white py-12 md:py-20">
      <div className="mx-auto max-w-[90rem] px-6 md:px-8">
        <div className="text-center">
          <h2 className="text-2xl font-light uppercase tracking-wide text-primaryLoc md:text-4xl">
            {chrome.heading}
          </h2>
          <p className="mt-2 text-sm text-primaryLoc/80 md:text-lg">
            {chrome.subheading}
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:mt-14 lg:grid-cols-3 lg:gap-6">
          {featuredVehicles.map((vehicle, index) => (
            <motion.div
              key={vehicle.id}
              initial={false}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.45, delay: index * 0.06 }}
              whileHover={{ y: -4 }}
            >
              <VehicleCard vehicle={vehicle} locale={locale} />
            </motion.div>
          ))}
        </div>

        <div className="mt-8 text-center lg:mt-14">
          <Link
            href={vehiclesBasePath(locale)}
            className="inline-flex items-center justify-center rounded-full border border-primaryLoc px-8 py-3 text-sm font-semibold text-primaryLoc transition-colors hover:bg-primaryLoc hover:text-white"
          >
            {chrome.seeAll}
          </Link>
        </div>
      </div>
    </section>
  );
}
